module.exports = "pegasus/assets/themelp1/small/11.png";